export const categories = [
  { name: '全部', slug: 'all' },
  { name: '足球', slug: 'football' },
  { name: '篮球', slug: 'basketball' },
  { name: '电竞', slug: 'esports' },
  { name: '网球', slug: 'tennis' },
  { name: '综合', slug: 'general' },
];

export const articles = [
  {
    id: 'article-1',
    title: '2026世界杯预选赛亚洲区：中国队2-1击败日本队，晋级形势大逆转',
    excerpt: '在昨晚进行的世界杯亚洲区预选赛关键战中，中国男足凭借武磊和张玉宁的进球，以2-1力克日本队，为晋级之路增添了重要砝码。',
    content: `<p>在昨晚进行的2026年世界杯亚洲区预选赛关键战中，中国男足在主场以2-1力克日本队，拿下了一场至关重要的胜利。这场胜利不仅让中国队积分跃升至小组第二，更让全队士气大振。</p>
    <p>比赛第23分钟，武磊接队友传中头球破门，为中国队首开纪录。下半场第58分钟，张玉宁利用角球机会头槌再下一城。日本队在第76分钟扳回一球，但中国队凭借顽强的防守将比分保持到了终场。</p>
    <p>主教练赛后表示："这是团队的胜利，每一位球员都拼尽了全力。我们还有很长的路要走，但这场胜利给了我们极大的信心。"</p>
    <p>目前中国队以14分位居小组第二，距离小组头名澳大利亚队仅差2分。最后两轮比赛，中国队将分别客场挑战沙特阿拉伯和主场迎战越南队。</p>
    <p><strong>关键数据：</strong></p>
    <ul>
    <li>控球率：中国队42% - 58%日本队</li>
    <li>射门次数：中国队8次 - 12次日本队</li>
    <li>角球：中国队5次 - 7次日本队</li>
    <li>黄牌：中国队2张 - 日本队1张</li>
    </ul>`,
    category: '足球',
    categorySlug: 'football',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20national%20football%20team%20celebrating%20victory%20on%20stadium%20pitch%2C%20dramatic%20sports%20photography%2C%20red%20jersey%2C%20floodlights%2C%20professional%20soccer%20match%20atmosphere%2C%20emotion%20and%20passion%2C%20sports%20journalism%20style&width=800&height=500&seq=article-football-1&orientation=landscape',
    author: '李明',
    publishDate: '2026-08-07',
    readTime: '5分钟',
    tags: ['世界杯预选赛', '中国足球', '日本队', '武磊'],
    featured: true,
    trending: true,
  },
  {
    id: 'article-2',
    title: 'NBA夏季联赛：文班亚马狂砍42分，马刺新赛季前景获看好',
    excerpt: '维克托·文班亚马在NBA夏季联赛中展现出统治级表现，单场砍下42分15篮板7盖帽，引发全联盟对新赛季的无限期待。',
    content: `<p>NBA夏季联赛继续进行，圣安东尼奥马刺队的法国天才维克托·文班亚马打出了令人瞠目结舌的表现，在对阵休斯顿火箭队的比赛中狂砍42分、15个篮板和7次盖帽。</p>
    <p>这位身高2米26的超级新星在比赛中展现了全方位的统治力——内线暴扣、中距离跳投、三分远射，甚至还有几次令人惊叹的控球突破。他的防守覆盖面更是让对手窒息。</p>
    <p>"他就像来自另一个星球，"一位NBA球探在赛后评价道，"我从未见过一个球员能同时拥有这样的身高和技巧。如果他保持健康，天空才是他的极限。"</p>
    <p>马刺队主教练格雷格·波波维奇在采访中表示："维克托每天都在进步，他的职业态度令人钦佩。新赛季我们有很多值得期待的地方。"</p>
    <p>随着新赛季的临近，马刺队被多家媒体列为西部潜在的黑马球队，文班亚马也被视为MVP热门候选人之一。</p>`,
    category: '篮球',
    categorySlug: 'basketball',
    imageUrl: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20player%20dunking%20dramatically%20in%20arena%2C%20tall%20athletic%20player%20in%20silver%20and%20black%20jersey%2C%20professional%20sports%20photography%2C%20arena%20lights%2C%20dynamic%20action%20shot%2C%20crowd%20in%20background&width=800&height=500&seq=article-basketball-1&orientation=landscape',
    author: '王浩然',
    publishDate: '2026-08-07',
    readTime: '4分钟',
    tags: ['NBA', '文班亚马', '马刺', '夏季联赛'],
    featured: true,
    trending: true,
  },
  {
    id: 'article-3',
    title: '英雄联盟S16全球总决赛：BLG让二追三逆转T1，首夺世界冠军',
    excerpt: '在刚刚结束的英雄联盟S16全球总决赛中，BLG战队在0-2落后的绝境下连扳三局，以3-2逆转T1战队，为中国LPL赛区再添一座世界冠军奖杯。',
    content: `<p>2026年英雄联盟全球总决赛（S16）在巴黎落下帷幕，中国LPL赛区的BLG战队在一场荡气回肠的BO5决赛中，以3-2逆转战胜韩国LCK赛区的T1战队，首次捧起召唤师奖杯。</p>
    <p>比赛开局并不顺利，T1连下两城以2-0领先，BLG被逼入绝境。然而从第三局开始，BLG展现出了惊人的韧性。打野Xun的蔚在野区频频找到机会，中单Knight的阿卡丽多次打出精彩操作。</p>
    <p>决胜局中，BLG在35分钟的关键团战中打出完美配合，ADC Elk的金克丝完成收割，团灭对手后一波推平基地。当水晶爆炸的那一刻，五位选手相拥而泣，全场观众起立鼓掌。</p>
    <p>"这是我们所有人梦寐以求的时刻，"队长Bin在赛后采访中哽咽道，"我们从未放弃，即使在0-2落后的时候，我们也相信彼此。"</p>
    <p>这是LPL赛区自S11以来再次夺得全球总决赛冠军，也标志着中国英雄联盟电竞的全面复兴。</p>`,
    category: '电竞',
    categorySlug: 'esports',
    imageUrl: 'https://readdy.ai/api/search-image?query=esports%20team%20celebrating%20championship%20on%20stage%20with%20trophy%2C%20confetti%20falling%2C%20gaming%20arena%20with%20screens%2C%20professional%20esports%20photography%2C%20dramatic%20lighting%2C%20excited%20young%20players%20in%20team%20jersey&width=800&height=500&seq=article-esports-1&orientation=landscape',
    author: '张伟',
    publishDate: '2026-08-06',
    readTime: '5分钟',
    tags: ['英雄联盟', 'S16', 'BLG', 'T1', '全球总决赛'],
    featured: true,
    trending: true,
  },
  {
    id: 'article-4',
    title: '法网公开赛：郑钦文直落两盘击败世界第一，历史性晋级决赛',
    excerpt: '中国金花郑钦文在法网半决赛中以6-4、6-3直落两盘击败世界排名第一的斯瓦泰克，成为李娜之后第二位闯入大满贯决赛的中国选手。',
    content: `<p>在罗兰·加洛斯的红土赛场上，中国选手郑钦文创造了历史。她以6-4、6-3直落两盘击败世界排名第一的波兰选手斯瓦泰克，成功晋级法国网球公开赛女单决赛。</p>
    <p>整场比赛中，郑钦文的正手进攻火力全开，共轰出28记制胜分。她的发球表现同样出色，一发得分率高达76%。相比之下，斯瓦泰克全场出现了23次非受迫性失误，显得异常焦躁。</p>
    <p>"这是我人生中最重要的一场比赛，"郑钦文赛后激动地说，"站在这里，我想起了李娜姐姐当年的辉煌。我希望能让中国网球再次闪耀世界。"</p>
    <p>郑钦文的决赛对手将是白俄罗斯选手萨巴伦卡。如果获胜，她将成为中国网球历史上第一位法网冠军，也是继李娜之后第二位获得大满贯单打冠军的中国选手。</p>
    <p>全国球迷的热情也被点燃，社交媒体上"郑钦文法网决赛"的话题迅速冲上热搜榜首。</p>`,
    category: '网球',
    categorySlug: 'tennis',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20female%20tennis%20player%20hitting%20forehand%20on%20red%20clay%20court%2C%20professional%20tennis%20photography%2C%20Roland%20Garros%20stadium%2C%20athletic%20action%20shot%2C%20intense%20expression%2C%20warm%20sunlight&width=800&height=500&seq=article-tennis-1&orientation=landscape',
    author: '刘洋',
    publishDate: '2026-08-06',
    readTime: '4分钟',
    tags: ['法网', '郑钦文', '网球', '大满贯'],
    featured: false,
    trending: true,
  },
  {
    id: 'article-5',
    title: '西甲转会市场：巴萨1.2亿欧元报价姆巴佩，巴黎态度松动',
    excerpt: '巴塞罗那俱乐部据传已向巴黎圣日耳曼提出1.2亿欧元的正式报价，试图签下法国巨星姆巴佩，巴黎方面首次表现出谈判意愿。',
    content: `<p>西甲转会窗口迎来了爆炸性消息。据多家欧洲权威媒体报道，巴塞罗那俱乐部已正式向巴黎圣日耳曼提出1.2亿欧元的报价，求购法国超级巨星基利安·姆巴佩。</p>
    <p>消息人士透露，巴黎圣日耳曼方面首次表现出了谈判意愿。姆巴佩与巴黎的合同还剩两年，但球员本人据称对加盟巴萨持开放态度，尤其是在巴萨新任主教练亲自致电游说之后。</p>
    <p>如果这笔转会最终达成，将成为足球史上第二贵的转会交易，仅次于内马尔2017年以2.22亿欧元加盟巴黎的纪录。</p>
    <p>巴萨主席在最近一次采访中表示："我们始终在寻找让球队变得更好的方式。姆巴佩是世界上最好的球员之一，任何俱乐部都会对他感兴趣。"</p>
    <p>不过，巴萨的财政状况仍然是一个巨大的问号。俱乐部需要通过出售部分球员来满足财政公平法案的要求，这也给这笔转会增添了不确定性。</p>`,
    category: '足球',
    categorySlug: 'football',
    imageUrl: 'https://readdy.ai/api/search-image?query=professional%20football%20player%20in%20Barcelona%20jersey%20celebrating%20goal%20in%20stadium%2C%20dramatic%20soccer%20photography%2C%20Camp%20Nou%20atmosphere%2C%20floodlights%2C%20passionate%20celebration%2C%20editorial%20sports%20style&width=800&height=500&seq=article-football-2&orientation=landscape',
    author: '陈明',
    publishDate: '2026-08-05',
    readTime: '3分钟',
    tags: ['西甲', '转会', '姆巴佩', '巴萨'],
    featured: false,
    trending: false,
  },
  {
    id: 'article-6',
    title: 'CBA新赛季前瞻：广东宏远签下NBA冠军中锋，志在卫冕',
    excerpt: '广东宏远篮球俱乐部官方宣布，已与前NBA冠军中锋贾维尔·麦基签下一份为期两年的合同，球队新赛季卫冕决心十足。',
    content: `<p>CBA卫冕冠军广东宏远篮球俱乐部今日官方宣布，已与拥有三枚NBA总冠军戒指的中锋贾维尔·麦基完成签约，合同为期两年，总价值约为800万美元。</p>
    <p>麦基今年34岁，身高2米13，臂展达到惊人的2米29。他在NBA效力17个赛季，曾随金州勇士和洛杉矶湖人三度夺得总冠军。上赛季他在NBA场均贡献8.2分和5.7个篮板。</p>
    <p>"我非常兴奋能来到中国打球，"麦基在加盟发布会上说，"CBA是一个竞争激烈的联赛，我听说过很多关于这里的故事。我的目标是帮助广东队再次夺冠。"</p>
    <p>广东宏远主教练杜锋表示："麦基的加盟将极大提升我们的内线实力。他的防守覆盖面、篮下终结能力和冠军经验都是我们所需要的。"</p>
    <p>随着麦基的加盟，广东宏远新赛季的阵容堪称豪华：麦基镇守内线，周鹏和胡明轩领衔外线，赵睿掌控后场。球队卫冕的决心已经不言而喻。</p>`,
    category: '篮球',
    categorySlug: 'basketball',
    imageUrl: 'https://readdy.ai/api/search-image?query=professional%20basketball%20center%20player%20dunking%20in%20Chinese%20basketball%20arena%2C%20CBA%20game%20action%20shot%2C%20tall%20athlete%20in%20blue%20jersey%2C%20dramatic%20sports%20photography%2C%20indoor%20stadium%20lighting&width=800&height=500&seq=article-basketball-2&orientation=landscape',
    author: '王浩然',
    publishDate: '2026-08-05',
    readTime: '3分钟',
    tags: ['CBA', '广东宏远', '麦基', '转会'],
    featured: false,
    trending: false,
  },
  {
    id: 'article-7',
    title: 'DOTA2国际邀请赛TI14：三支中国战队锁定直邀名额',
    excerpt: '随着DPC赛季收官，三支中国DOTA2战队——LGD、Aster和XG凭借全年优异表现，成功锁定TI14直邀名额。',
    content: `<p>DOTA2 DPC赛季落下帷幕，国际邀请赛TI14的直邀名单正式出炉。中国赛区共有三支战队凭借全年稳定的发挥获得直邀资格——PSG.LGD、Team Aster和Xtreme Gaming。</p>
    <p>PSG.LGD以中国区DPC积分第一的身份锁定直邀名额，他们在本赛季拿下了两个Major冠军，展现出了强大的统治力。Team Aster和Xtreme Gaming则分别排名中国区第二和第三。</p>
    <p>"今年中国区的竞争非常激烈，"一位DOTA2分析师评价道，"三支直邀队伍都有冲击冠军的实力，尤其是LGD，他们在国际赛场上的表现令人印象深刻。"</p>
    <p>TI14将于今年10月在哥本哈根举行，总奖金池预计将超过4000万美元。除了三支直邀队伍外，还有两支中国战队将通过地区预选赛争夺额外的参赛名额。</p>
    <p>中国DOTA2粉丝对今年的TI充满期待，希望中国战队能够终结长达多年的冠军荒。</p>`,
    category: '电竞',
    categorySlug: 'esports',
    imageUrl: 'https://readdy.ai/api/search-image?query=DOTA2%20esports%20team%20playing%20on%20stage%20with%20headsets%2C%20intense%20gaming%20competition%2C%20computer%20screens%20with%20game%20graphics%2C%20professional%20esports%20photography%2C%20colorful%20stage%20lighting%2C%20focused%20young%20players&width=800&height=500&seq=article-esports-2&orientation=landscape',
    author: '张伟',
    publishDate: '2026-08-04',
    readTime: '3分钟',
    tags: ['DOTA2', 'TI14', 'LGD', '电竞'],
    featured: false,
    trending: false,
  },
  {
    id: 'article-8',
    title: '中国女排3-0横扫巴西队，世界女排联赛豪取八连胜',
    excerpt: '中国女排在世界女排联赛中继续高歌猛进，以3-0完胜巴西女排，豪取八连胜，稳居积分榜首位。',
    content: `<p>中国女排延续了近期火热的状态，在世界女排联赛中以3-0（25-21、25-18、25-22）横扫巴西女排，取得八连胜的同时继续稳坐积分榜头把交椅。</p>
    <p>本场比赛中，主攻手李盈莹拿下全场最高的18分，接应龚翔宇贡献14分，副攻袁心玥也有11分入账。中国女排在发球、拦网和防守端全面压制了巴西队。</p>
    <p>"我们的团队配合越来越好，"主教练蔡斌赛后表示，"每一位球员都在为团队做出贡献。八连胜只是一个开始，我们的目标是在总决赛中拿到冠军。"</p>
    <p>中国女排接下来将在周末迎战老对手美国队，这将是一场榜首之争的关键战役。目前中国队以26分高居榜首，美国队以24分紧随其后。</p>
    <p>全国球迷对女排的表现给予了高度评价，社交媒体上充满了对球队的支持和鼓励。</p>`,
    category: '综合',
    categorySlug: 'general',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20women%20volleyball%20team%20celebrating%20victory%20on%20court%2C%20red%20and%20yellow%20jerseys%2C%20indoor%20volleyball%20stadium%2C%20professional%20sports%20photography%2C%20team%20spirit%2C%20joyful%20celebration%20moments&width=800&height=500&seq=article-general-1&orientation=landscape',
    author: '赵丽',
    publishDate: '2026-08-04',
    readTime: '3分钟',
    tags: ['女排', '世界联赛', '李盈莹', '排球'],
    featured: false,
    trending: false,
  },
  {
    id: 'article-9',
    title: '英超新赛季赛程公布：揭幕战曼城对阵利物浦引爆全球关注',
    excerpt: '2026-27赛季英超联赛官方赛程正式公布，卫冕冠军曼城将在揭幕战中主场迎战利物浦，这场强强对话成为全球焦点。',
    content: `<p>英超官方今日正式公布了2026-27赛季的完整赛程。最引人注目的莫过于揭幕战——卫冕冠军曼彻斯特城将在伊蒂哈德球场迎战利物浦，这场重量级对决将于8月15日打响。</p>
    <p>新赛季的赛程编排颇具看点：首月就将上演曼城对利物浦、阿森纳对切尔西等多场强强对话。圣诞赛程中，曼联与利物浦的"双红会"将于12月26日节礼日上演。</p>
    <p>"英超的赛程安排总是充满戏剧性，"一位英超评论员分析道，"将曼城和利物浦放在揭幕战是一个大胆的选择，但这正是球迷们想看到的——从第一天起就是巅峰对决。"</p>
    <p>随着新赛季的临近，各支球队都在加紧引援和备战。曼城在夏窗已经签下了两名新援，而利物浦也在积极补强阵容。新赛季的英超冠军争夺预计将比以往更加激烈。</p>`,
    category: '足球',
    categorySlug: 'football',
    imageUrl: 'https://readdy.ai/api/search-image?query=English%20Premier%20League%20football%20match%20in%20packed%20stadium%2C%20Manchester%20City%20versus%20Liverpool%2C%20intense%20soccer%20action%2C%20floodlights%2C%20professional%20sports%20photography%2C%20dramatic%20atmosphere%2C%20players%20in%20motion&width=800&height=500&seq=article-football-3&orientation=landscape',
    author: '陈明',
    publishDate: '2026-08-03',
    readTime: '3分钟',
    tags: ['英超', '曼城', '利物浦', '赛程'],
    featured: false,
    trending: false,
  },
  {
    id: 'article-10',
    title: '巴黎奥运会倒计时两周年：中国代表团备战工作全面提速',
    excerpt: '距离2028年洛杉矶奥运会开幕还有两年时间，中国体育代表团各项目备战工作已进入冲刺阶段，多个项目展现出夺金实力。',
    content: `<p>随着2028年洛杉矶奥运会倒计时进入两周年，中国体育代表团的备战工作正在全面提速。国家体育总局日前召开了奥运备战工作会议，对各项目的训练计划和参赛目标进行了部署。</p>
    <p>在传统优势项目方面，中国跳水队和乒乓球队依然保持着世界领先地位。游泳项目中，新一代年轻选手的崛起令人振奋。田径项目上，中国队在女子投掷和竞走项目上具备争金实力。</p>
    <p>"洛杉矶奥运会的竞争将更加激烈，"国家体育总局相关负责人表示，"我们的目标是在保持传统优势项目领先地位的同时，在更多项目上取得突破。"</p>
    <p>值得一提的是，霹雳舞、滑板、攀岩等新兴奥运项目也将是中国代表团的重要突破口，年轻选手在这些项目上展现出了不俗的潜力。</p>
    <p>未来两年，中国运动员将参加一系列国际赛事，为洛杉矶奥运会积累经验、检验训练成果。</p>`,
    category: '综合',
    categorySlug: 'general',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20Olympic%20athletes%20training%20in%20modern%20sports%20facility%2C%20red%20and%20gold%20uniforms%2C%20professional%20training%20scene%2C%20determination%20and%20focus%2C%20indoor%20sports%20complex%2C%20editorial%20photography&width=800&height=500&seq=article-general-2&orientation=landscape',
    author: '赵丽',
    publishDate: '2026-08-03',
    readTime: '4分钟',
    tags: ['奥运会', '洛杉矶', '中国代表团', '备战'],
    featured: false,
    trending: false,
  },
  {
    id: 'article-11',
    title: 'NBA交易市场：湖人送出三首轮签换得特雷杨，组建超级后场',
    excerpt: '湖人队与老鹰队达成重磅交易，送出三个未来首轮选秀权和两名球员，换得全明星控卫特雷杨，与詹姆斯组成超级后场。',
    content: `<p>NBA交易市场再掀波澜。据ESPN名记沃纳罗斯基报道，洛杉矶湖人队与亚特兰大老鹰队达成了一笔重磅交易：湖人送出2027年、2029年和2031年的首轮选秀权，以及奥斯汀·里夫斯和贾里德·范德比尔特，换得全明星控卫特雷杨。</p>
    <p>这笔交易将让湖人的后场实力大幅提升。特雷杨上赛季场均贡献28.7分和10.4次助攻，是联盟顶级的进攻组织者。他与勒布朗·詹姆斯的搭档令人期待。</p>
    <p>"湖人终于为詹姆斯找到了真正的后场搭档，"一位NBA分析师评价道，"特雷杨的投射能力和挡拆威胁将为湖人打开全新的进攻维度。当然，防守端可能会有些问题，但进攻火力的提升是显而易见的。"</p>
    <p>西部联盟的竞争格局因这笔交易再次发生变化。湖人、掘金、勇士和太阳的军备竞赛愈演愈烈，新赛季的西部将是一场不折不扣的"杀戮战场"。</p>`,
    category: '篮球',
    categorySlug: 'basketball',
    imageUrl: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20star%20player%20dribbling%20ball%20in%20Los%20Angeles%20Lakers%20gold%20jersey%2C%20professional%20sports%20photography%2C%20Staples%20Center%20atmosphere%2C%20dramatic%20arena%20lighting%2C%20action%20shot&width=800&height=500&seq=article-basketball-3&orientation=landscape',
    author: '王浩然',
    publishDate: '2026-08-02',
    readTime: '3分钟',
    tags: ['NBA', '湖人', '特雷杨', '交易'],
    featured: false,
    trending: false,
  },
  {
    id: 'article-12',
    title: 'F1匈牙利大奖赛：周冠宇雨战发挥出色，第五名创个人赛季最佳',
    excerpt: '中国F1车手周冠宇在匈牙利大奖赛的雨战中表现出色，以第五名的成绩完赛，创下个人本赛季最佳成绩。',
    content: `<p>F1匈牙利大奖赛在布达佩斯赛道落下帷幕。中国车手周冠宇在复杂的雨战条件下发挥出色，从第11位发车最终以第五名完赛，创造了个人本赛季的最佳成绩。</p>
    <p>比赛当天的天气条件极为复杂，赛道时干时湿。周冠宇在关键时刻做出了正确的轮胎策略选择，并在赛道上的多次超车展现了精湛的驾驶技术。</p>
    <p>"这是我本赛季最满意的一场比赛，"周冠宇赛后表示，"车队在策略上做出了完美的决策，我也在赛道上抓住了每一个机会。第五名对我们来说意义重大。"</p>
    <p>周冠宇所在的阿尔法·罗密欧车队本赛季表现稳步提升，本场比赛的双积分更是让车队在制造商积分榜上大幅前进。</p>
    <p>F1下一站将移师比利时斯帕赛道，周冠宇希望能在"世界上最美丽的赛道"上延续良好状态。</p>`,
    category: '综合',
    categorySlug: 'general',
    imageUrl: 'https://readdy.ai/api/search-image?query=Formula%201%20race%20car%20on%20wet%20racing%20track%20with%20water%20spray%2C%20Chinese%20F1%20driver%2C%20dramatic%20motorsport%20photography%2C%20speed%20and%20motion%20blur%2C%20racing%20circuit%20atmosphere%2C%20professional%20sports%20action&width=800&height=500&seq=article-general-3&orientation=landscape',
    author: '刘洋',
    publishDate: '2026-08-02',
    readTime: '3分钟',
    tags: ['F1', '周冠宇', '匈牙利', '赛车'],
    featured: false,
    trending: false,
  },
];

export const trendingArticles = articles.filter(a => a.trending);
export const featuredArticles = articles.filter(a => a.featured);

export const aboutData = {
  brandName: '乐鱼体育资讯中心',
  intro: '乐鱼体育资讯中心成立于2022年，是专注于体育资讯报道的综合媒体平台。我们致力于为中文体育爱好者提供权威、及时、全面的体育新闻与赛事资讯服务。',
  mission: '以专业的态度传递体育力量，让每一位体育爱好者都能第一时间了解全球体育动态。',
  history: [
    { year: '2022', event: '乐鱼体育资讯中心正式上线，聚焦足球、篮球领域' },
    { year: '2023', event: '拓展电竞、网球等垂直领域，月活跃用户突破500万' },
    { year: '2024', event: '推出赛事直播资讯服务，与多家国际体育组织建立合作' },
    { year: '2025', event: '成为中国领先的体育资讯平台，日均访问量突破千万' },
    { year: '2026', event: '全面升级内容生态，引入AI智能推荐，覆盖20+体育品类' },
  ],
  reputation: [
    { title: '权威性', description: '与全球50+体育组织和赛事方建立官方合作，确保信息的一手来源和准确性。' },
    { title: '及时性', description: '7x24小时全天候更新，重大赛事实时滚动报道，平均发稿速度领先行业30%。' },
    { title: '专业性', description: '拥有200+资深体育编辑和记者团队，多位前职业运动员担任特约评论员。' },
    { title: '创新性', description: '运用AI技术实现个性化内容推荐，智能赛事数据分析和可视化呈现。' },
    { title: '影响力', description: '月活跃用户超过5000万，社交媒体总粉丝量突破8000万，体育类APP排名前三。' },
    { title: '公信力', description: '连续三年获得"年度最具公信力体育媒体"殊荣，内容被主流媒体广泛引用。' },
  ],
  contact: {
    address: '北京市朝阳区建国路88号SOHO现代城A座18层',
    phone: '400-888-6688',
    email: 'contact@leyusports.com',
    businessHours: '周一至周五 9:00 - 18:00',
  },
};

export const faqData = [
  {
    question: '乐鱼体育资讯中心的内容来源是什么？',
    answer: '我们的内容来自全球200+专业体育记者和编辑团队的原创报道，同时与50+国际体育组织和赛事方建立了官方合作，确保信息的一手来源和准确性。所有内容均经过多轮审核后发布。',
  },
  {
    question: '如何订阅乐鱼体育资讯中心的推送通知？',
    answer: '您可以在网站首页点击"订阅"按钮，输入您的邮箱地址即可完成订阅。我们将每日为您推送精选体育新闻，让您不错过任何重要赛事动态。',
  },
  {
    question: '乐鱼体育资讯中心是否提供赛事直播服务？',
    answer: '乐鱼体育资讯中心主要提供赛事直播资讯和实时比分更新服务。对于完整的赛事直播视频，我们会在相关文章中提供合法的直播平台链接，方便您观看比赛。',
  },
  {
    question: '如何联系我们进行商务合作或广告投放？',
    answer: '您可以通过"关于我们"页面的联系方式与我们取得联系，或直接发送邮件至contact@leyusports.com。我们的商务团队将在1-2个工作日内给您回复。',
  },
  {
    question: '乐鱼体育资讯中心支持哪些设备访问？',
    answer: '乐鱼体育资讯中心支持PC端、移动端和平板设备访问，采用响应式设计，确保在不同屏幕尺寸下都能获得良好的阅读体验。您也可以将网站添加到手机主屏幕，像使用原生App一样便捷访问。',
  },
];